import { get, split } from 'lodash';

import { ENVIRONMENTS } from 'constants/environments';
import Settings from 'utils/Settings';

// This isn't secret, so its okay to expose to users
const DATADOG_LOGGER_SECRETS = {
  [ENVIRONMENTS.DEVELOPMENT]: 'pubc6ad3e51ca841e98ee216de1da17b49c',
  [ENVIRONMENTS.STAGING]: 'pubc6ad3e51ca841e98ee216de1da17b49c',
  [ENVIRONMENTS.PRODUCTION]: 'pub75727705086793f9de48d47553dd0fe9',
};

// This mapping is needed to have parity with the native app
const ENV_MAP = {
  [ENVIRONMENTS.DEVELOPMENT]: 'dev',
  [ENVIRONMENTS.STAGING]: 'test',
  [ENVIRONMENTS.PRODUCTION]: 'prod',
};

const SERVICE = 'allbirds-web-app';
const ENVIRONMENT = get(ENV_MAP, Settings.environment);
const clientName = 'Allbirds Web App';
const geoCode = `${Settings.shopID}_WEB`;
const shopName = split(Settings.shopPermanentDomain, '.')[0];

// camelCased as these keys are fed directly into datadog
const DEFAULT_ATTRIBUTES = {
  clientName,
  geoCode,
  locale: Settings.shopLocale,
  shopName,
  isHydrogen: false,
};

export { DATADOG_LOGGER_SECRETS, SERVICE, ENVIRONMENT, DEFAULT_ATTRIBUTES };
